'use client';
import { FieldReadFunction } from '@apollo/client';
import { BundleCartItemWithProduct } from '@storefront/adapters/LineItemAdapter';
import { BundleCartItem } from '@storefront/data-commerce';

import { toLineItems } from '../lineItems/utils';

export const cartStateResolver: FieldReadFunction<any> = (
  cached: BundleCartItem[]
) => {
  const lineItems = toLineItems(cached as BundleCartItemWithProduct[]);
  return cached.map((item) => ({ ...item, lineItems }));
};
